import { transition, trigger, useAnimation } from '@angular/animations';
import { Params, Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { AccountType } from '@mnz-core/models/_enums';
import { IRootState } from '@mnz-core/modules/store/models/root-state';
import * as routerSelectors from '@mnz-core/modules/store/selectors/router.selectors';
import { select, Store } from '@ngrx/store';
import { fadeIn } from 'ng-animate';
import { first, map } from 'rxjs/operators';
import * as authActions from '@mnz-modules/login/store/actions/auth.actions';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'mnz-auth',
  templateUrl: 'auth.page.html',
  animations: [trigger('fadeIn', [transition('* => *', useAnimation(fadeIn, { params: { timing: 0.5 } }))])],
})
export class AuthPage implements OnInit {
  constructor(
    @Inject(APP_CONFIG) private readonly _config: IAppConfiguration,
    private readonly _store$: Store<IRootState>,
    private readonly _router: Router
  ) {}

  readonly accountTypeEnum = AccountType;

  readonly accountType$ = this._store$.pipe(
    select(routerSelectors.getParams),
    map<Params, AccountType>(({ account }) => account)
  );

  backToOverview(): void {
    this._router.navigate(['/']);
  }

  async toRequestAccount(): Promise<void> {
    const accountType = await firstValueFrom(this.accountType$);
    this._router.navigate([`/account-activeren/${accountType}`]);
  }

  goToMoreInfo(): void {
    const { ns_business_url } = this._config.footerUrls;
    location.assign(ns_business_url);
  }

  ngOnInit(): void {
    // ensure user is logged out
    this._store$.dispatch(authActions.logout());
  }
}
